import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PwaService } from '../../../core/services/pwa.service';
import { SettingsService } from '../../../core/services/settings.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-pwa-install-prompt',
  templateUrl: './pwa-install-prompt.component.html',
  styleUrls: ['./pwa-install-prompt.component.scss']
})
export class PwaInstallPromptComponent implements OnInit, OnDestroy {
  showPrompt = false;
  isInstalling = false;
  companyName = 'Bilali Islamic Shopping';
  private destroy$ = new Subject<void>();
  private isBrowser: boolean;

  constructor(
    public pwaService: PwaService,
    private settingsService: SettingsService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.companyName = this.settingsService.getCompanyName();
  }

  ngOnInit(): void {
    if (!this.isBrowser) {
      return;
    }

    // Check if app can be installed after a delay (to avoid showing immediately)
    setTimeout(() => {
      this.checkInstallability();
    }, 3000);

    // Listen for installation status
    this.pwaService.isInstalled$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isInstalled => {
        if (isInstalled) {
          this.showPrompt = false;
        }
      });

    // Check if already in standalone mode
    this.pwaService.isStandalone$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isStandalone => {
        if (isStandalone) {
          this.showPrompt = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  checkInstallability(): void {
    if (!this.isBrowser) {
      return;
    }

    // Only show if not dismissed before and can install
    const dismissed = localStorage.getItem('pwa-install-dismissed');
    if (!dismissed && this.pwaService.canInstall()) {
      this.showPrompt = true;
    }
  }

  async install(): Promise<void> {
    if (!this.isBrowser) {
      return;
    }

    this.isInstalling = true;
    const installed = await this.pwaService.promptInstall();
    this.isInstalling = false;
    
    if (installed) {
      this.showPrompt = false;
    }
  }

  dismiss(): void {
    if (!this.isBrowser) {
      return;
    }

    this.showPrompt = false;
    localStorage.setItem('pwa-install-dismissed', 'true');
  }

  remindLater(): void {
    if (!this.isBrowser) {
      return;
    }

    this.showPrompt = false;
    // Show again after 24 hours
    setTimeout(() => {
      this.checkInstallability();
    }, 24 * 60 * 60 * 1000);
  }
}


